<app-nav></app-nav>
<section class="submission">
  <div class="container">
    <ng-container>
      <div class="col">
        <p class="sub-title mt-4" >Registered Claims</p>
        <div class="border rounded claimCards pt-2 content-box mt-4" *ngFor="let detail of cliamData">
          <span routerLink="/submit-detail/{{detail.intimationNo}}">
            <div class="row">
              <div class="col-6">
                <div class="row cardFields">Patient Name</div>
                <div class="row cardFieldsVal">{{detail.claimant}}</div>
              </div>
              <div class="col-6">
                <span class="row cardFields">Claimant</span>
                <span class="row cardFieldsVal">{{detail.employeeName}}</span>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-6">
                <div class="row cardFields">Date</div>
                <div class="row cardFieldsVal">{{detail.dateCreated | date:'dd/MM/yyyy'}}</div>
              </div>
              <div class="col-6">
                <div class="row cardFields">Registration No.</div>
                <div class="row cardFieldsVal" id={{detail.intimationNo}}>{{detail.intimationNo}}</div>
              </div>
            </div>
          </span>
        </div>
      </div>
    </ng-container>
    
  </div>
  <div class="modal fade" id="submitOpenModal" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
        <div class="modal-body claim-pop text-center">
          <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/submission/note.png" alt="">
          <p>It usually takes 3 to 4 weeks for the claim to be approved by the insurer.</p>
          <p>To expedite the claim approval processing time, please submit the scanned 
            copy of the documents followed by the dispatch of hard copies to SecureNow.</p>
            <div class="text-center">
            <button type="button" class="btn btn-blue" data-dismiss="modal">Got It</button>
            </div>
        </div>
        </div>
    </div>
  </div>

  <div class="modal fade" id="noRegisterClaimsModal" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
        <div class="modal-body claim-pop text-center">
            <div class="claim-icon-sorry">!</div>
            <h6>Sorry</h6>
            <p>You have not registered a claim yet. Please lodge a claim first.</p>
            <div class="text-center">
            <button type="button" class="btn btn-blue" data-dismiss="modal" routerLink="/home">Ok</button>
            </div>
        </div>
        </div>
    </div>
</div>

  <div id="spinner" [hidden]="!loading">
        <div class="spinnerfull">
            <i class="fa fa-spinner fa-spin fa-3x"></i>
        </div>
    </div>
</section>